import { Button, Input, Label } from '@crm/ui';
import { Trash2 } from 'lucide-react';
import type { ServiceTemplate } from '../api';

export interface ServicoEdicao {
  name?: string;
  durationMinutes?: number;
  price?: number;
}

interface ServiceTemplateRowProps {
  servico: ServiceTemplate;
  /** So os campos que a pessoa mexeu e ainda nao foram salvos. */
  pendente?: ServicoEdicao;
  onChange: (input: ServicoEdicao) => void;
  onRemove: () => void;
}

/**
 * Um servico: so nome, duracao e preco - servico nao precisa de foto propria.
 * Sem salvar proprio: o valor digitado fica pendente ate o Salvar unico da
 * tela (`templates-assistant.tsx`) mandar tudo de uma vez.
 */
export function ServiceTemplateRow({
  servico,
  pendente,
  onChange,
  onRemove,
}: ServiceTemplateRowProps) {
  const nome = pendente?.name ?? servico.name;
  const duracao = pendente?.durationMinutes ?? servico.durationMinutes;
  const preco = pendente?.price ?? servico.price;

  return (
    <div className="flex flex-wrap items-end gap-2 p-3">
      <div className="min-w-[160px] flex-1 space-y-1">
        <Label htmlFor={`servico-nome-${servico.id}`}>Nome do servico</Label>
        <Input
          id={`servico-nome-${servico.id}`}
          value={nome}
          onChange={(event) => onChange({ name: event.target.value })}
        />
      </div>

      <div className="w-24 space-y-1">
        <Label htmlFor={`servico-duracao-${servico.id}`}>Minutos</Label>
        <Input
          id={`servico-duracao-${servico.id}`}
          type="number"
          min={5}
          value={duracao}
          onChange={(event) => onChange({ durationMinutes: Number(event.target.value) || 0 })}
        />
      </div>

      <div className="w-28 space-y-1">
        <Label htmlFor={`servico-preco-${servico.id}`}>Preco padrao</Label>
        <Input
          id={`servico-preco-${servico.id}`}
          type="number"
          min={0}
          step="0.01"
          value={preco}
          onChange={(event) => onChange({ price: Number(event.target.value) || 0 })}
        />
      </div>

      <Button
        variant="ghost"
        size="icon"
        aria-label={`Remover ${servico.name}`}
        className="shrink-0 text-muted-foreground hover:text-destructive"
        onClick={onRemove}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
